export function replaceTextRecursive(instance: any, key: string, value: any) {

	if (Array.isArray(instance)) {
		for (let i = 0; i < instance.length; i++) {
			const child = instance[i];
			if (typeof child === 'string') {
				instance[i] = child.split(key).join(value);
			}
			else {
				replaceTextRecursive(child, key, value);
			}
		}
	}
	else
	if (typeof instance === 'object') {
		const keys = Object.keys(instance);
		for (const instanceKey of keys) {
			const child = instance[instanceKey];
			if (typeof child === 'string') {
				instance[instanceKey] = child.split(key).join(value);
			}
			else {
				replaceTextRecursive(child, key, value);
			}
		}
	}
	return instance;
}